export const deleteSeasonalRuleModalId = 'delete-seasonal-rule-modal';

export const APPLIES_TO_FIELD_NAME = 'appliesTo';
